import styled from 'styled-components'

const colorLine = '#E2E2E2'

type NavbarDropdownContentProps = {
    open: boolean
}

type NavbarDropdownProps ={
    open: boolean
}

type SelectedIconProps = {
    open: boolean
}

export const SelectedDescription = styled.label`
   display:flex;
   align-items:center;
   justify-content:center;
   min-height: 22px;
   font-size: 16px;
   color:#999999;
   cursor: pointer;
   
`

export const SelectedIcon = styled.div<SelectedIconProps>`
    display:${props => props.open ? "none":"flex"};
    align-items:center;
    justify-content:center;
    width:100%;
`

export const NavbarDropdownContent = styled.div<NavbarDropdownContentProps>`
    display: ${props => props.open ? "block":"none"};
    margin-top:44px;
    position: absolute;
    background-color: #FFFFFF;
    width:201px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0, 2);
    z-index: 1;
    cursor: pointer;
    
  `;

export const NavbarDropdown = styled.div<NavbarDropdownProps>`
    display: flex;
    outline: none !important;
    width: 201px;
    border-radius: 0 0 0 0;
    border: 1px solid ${colorLine};
    height:42px;
    font-size:16px;
    text-align-last: center;
    color:#999999;
    background-color: ${props => props.open ? "#E2E2E2":"#FFFFFF"};
    padding:0px;
    cursor: pointer;

        @media (min-width: 992px)
        and (max-width: 1280px){
           width: 14vw;
        }
`;

export const DropDownItem = styled.div`
    min-height:41px;
    font-size:16px;
    padding-left:15px;
    display: flex;
    height: 41px;
    align-items: center;
    &:hover {
        background-color:#F6F6F6;
    }

`

export const SelectTitleContainer = styled.div`
    display:grid;
    grid-template-columns:4fr 1fr;
    width: 20vw;
`
